import axios from "axios";

const CARRIER_TOKEN_ENDPOINT = 'https://app-selfserve-np-eus.ngsdevapps.net/api/auth/token';
export async function generateJwtToken(identity) {
  try {
    const identityPayload = {
        subId: identity.id, 
        actId: identity.onBehalfOfId,
        policyNumber: identity.policyNumber,
        companyCode: identity.companyCode,
        userEmail: identity.userEmail, 
        userFullName: identity.userFullName,
        userType: identity.userType,
        userPreferredLanguage: identity.userPreferredLanguage
    };

    const response = await axios.post(CARRIER_TOKEN_ENDPOINT, identityPayload, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    const jwtToken = response.data.jwtToken; 
        
        if (!jwtToken) {
            throw new Error("Backend did not return a valid token in the expected 'jwtToken' field.");
        }
        
        console.log("Successfully received signed JWT.");
        return jwtToken;
  } catch (error) {
    console.error("JWT generation failed:", error);
    throw error;
  }
}